<div *ngIf="!init" style="align-self: center;">
  <mat-spinner
    style="margin: auto;"
    color="primary"
    diameter="24"
  ></mat-spinner>
</div>
<div *ngIf="init" [ngClass]="displayListClass">
  <ul>
    <li *ngFor="let project of projects; let index = index; trackBy: trackById">
      <span
        class="clickable project-popup-entry"
        (click)="displayChild(index)"
        >{{ project.popupDisplay }}</span
      >
    </li>
  </ul>
</div>
<client-corner-project-info
  *ngFor="let project of projects; let index = index; trackBy: trackById"
  [index]="index"
  [project]="project"
  [toggleDisplay]="toggleDisplay"
  [alwaysDisplay]="alwaysDisplay"
  (backPressed)="backPressed()"
></client-corner-project-info>
